import { useQuery } from '@tanstack/react-query';
import { useSession } from './useSession';
import { fetchConfig } from '../lib/config';

/** App config (support contacts + FAQ) over the authed WS connection. Screens
 *  fall back to the mock when it hasn't loaded (dev/offline). */
export function useConfig() {
  const { token } = useSession();
  const q = useQuery({
    queryKey: ['config'],
    enabled: !!token,
    queryFn: fetchConfig,
    staleTime: 5 * 60_000,
  });
  return { config: q.data ?? null, loading: q.isLoading };
}
